import {type RawThread, type Thread, transformThreads} from '@/models/threadModel'
import call from '@/utils/api/call'
import shouldLogError from '@/utils/api/shouldLogError'
import waitAtLeast from '@/utils/waitAtLeast'

export async function getThreads({signal}: {signal: AbortSignal}) {
  return waitAtLeast(
    call
      .get<RawThread[]>('/api/threads/', {
        signal,
      })
      .then(res => {
        return transformThreads(res.data)
      })
      .catch(e => {
        if (shouldLogError(e)) {
          console.error('Cannot fetch threads', e)
        }
        return [] as Thread[]
      }),
    500,
  )
}
